/* @jsxImportSource react */

import * as React from 'react';

export interface PriceValueProps extends React.HTMLAttributes<Omit<HTMLSpanElement, 'className'>> {
  // This is used as a workaround until EDS3 has a correct size variant for the product cards
  fixedTextClass?: string;
}

const PriceValue = ({
  children,
  fixedTextClass,
  'aria-label': srLabel,
  ...props
}: PriceValueProps) => (
  <>
    {srLabel && <span className="sr-only">{srLabel}</span>}
    <span
      className={`price-value text-size-headline-xl whitespace-nowrap ${fixedTextClass ?? 'group-[.price-size-small]:text-size-headline-sm lg:text-size-headline-2xl lg:group-[.price-size-small]:text-size-headline-base'} inline-flex grow-0 items-center justify-start font-bold [grid-area:c]`}
      {...props}
    >
      {children}
    </span>
  </>
);

PriceValue.displayName = 'PriceValue';

export { PriceValue };
